import React from "react";
import Image from "next/image";
import { useTranslations } from "next-intl";
import Section_name from "./Section_name";
const Why_iPillion = () => {
  const t = useTranslations("ipillion.Why_iPillion");
  return (
    <div className="grid grid-cols-12 lg:gap-[20px] items-center lg:mt-24 mt-10 relative">
      <div className="relative  lg:h-[416px] lg:w-[561px] xl:w-[561px] xl:h-[416px] max-w-[315px] mix-blend-multiply lg:max-w-full h-[233.58px] col-span-12 lg:col-span-6">
        <Image
          src="/projects/iPillion/hero-biker.jpg"
          layout="fill"
          quality={100}
        />
      </div>
      <div className="col-span-12 sm:col-span-6 relative w-fit">
        <Section_name name={t("title")} color={"#D60014"} />
        <p className="max-w-[400px] lg:text-[18px] text-[14px] leading-[20px] lg:leading-[26px] font-[400] h-auto">
          {t("description")}
        </p>
      </div>
    </div>
  );
};

export default Why_iPillion;
